// Notify-when-back block.
// Loaded as a theme asset because inline <script> inside a Horizon block does not execute.
(function () {
  function init() {
    var blocks = document.querySelectorAll('[data-notify-block]');

    Array.prototype.forEach.call(blocks, function (root) {
      if (root.getAttribute('data-notify-ready') === 'true') return;
      root.setAttribute('data-notify-ready', 'true');

      var form = root.querySelector('form');
      var fields = root.querySelector('[data-notify-fields]');
      var success = root.querySelector('[data-notify-success]');
      if (!form || !fields || !success) return;

      function reveal() {
        fields.hidden = true;
        success.hidden = false;
      }

      // Fallback for a native submit (JS blocked, or fetch unavailable).
      // Shopify round-trips through /contact and returns with ?customer_posted=true
      // plus this form's own #id fragment, because the block passes id: to the form tag.
      // The theme's other customer form (the newsletter block on the same product page)
      // passes no id, so it can never produce this hash. That is what makes the
      // confirmation safe to show here without reading form.posted_successfully?.
      if (
        window.location.search.indexOf('customer_posted=true') !== -1 &&
        form.id &&
        window.location.hash === '#' + form.id
      ) {
        reveal();
      }

      form.addEventListener('submit', function (event) {
        // Let the browser show native validation for an empty or malformed email.
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

        event.preventDefault();

        var button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;

        // form.action carries any locale prefix. Strip the fragment before posting.
        fetch(form.action.split('#')[0], {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' }
        })
          .then(reveal)
          .catch(function () {
            // Network failure: hand it back to the browser's native submit.
            if (button) button.disabled = false;
            form.submit();
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', init);
})();
